import React, { useState, useEffect} from 'react';
import Slider from 'react-slick'

import server from 'server/serverController2';
import constants from 'utils/constants'

import { MainBannerBlock, MainBannerItem, BannerDots } from 'components/presenters/banner/MainBanner';

export default function StoreMainBanner() {
  const [bannerList, setBannerList] = useState([]);

  const loadBanners = async () => {
    try {
      const response = await server.getRequestData('commerce/banners');
      if(response.success !== 1) {
        const errData = response.error.res_data;
        throw errData;
      }

      const { banners } = response.data;
      
      setBannerList(banners);
    } catch(error) {
      console.log(error);
    }
  }

  useEffect(() => {
    loadBanners();
  }, [])

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 500,
    autoPlaySpeed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    appendDots: (dots) => {
      return <BannerDots dots={dots}/>
    }
  }
  
  return (
    <MainBannerBlock>
      <Slider {...settings}>
        {bannerList?.map(banner => (
          <MainBannerItem 
            key={`motishop-banner-no-${banner.no}`} 
            type={banner.type}
            externalLink={banner.link}
            path={banner.path}
            imageSrc={`${constants.imagePath}/commerce/main_banner_img/${banner?.banner_cover_img}`}
          />
        ))}
      </Slider>
    </MainBannerBlock>
  )
}